import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../services/login.service';
import { ForgotPassword, Login } from '../models/loginModel';
import { LoggedInUserInfo, LoggedInUserAccessDetails } from '../models/loggedInUserModel';
import { Error } from '../models/errorModel';
import { AuthService } from '../services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone: false
})
export class LoginFormComponent {
  login: Login = new Login('', '', false, '', '');
  forgotPwd: ForgotPassword = new ForgotPassword('', '', false, false, false, '', '');
  user?: LoggedInUserInfo;
  errorMessage: string = '';
  firstlogin: string = 'false';

  constructor(private loginService: LoginService, private route: ActivatedRoute, private router: Router, private authService: AuthService) {

  }

  ngOnInit(): void {
    var stageName = this.parseStage(window.location.hostname) || '';
    if (stageName !== '')
      this.authService.loginHostName$.next(stageName+'.');
    else
      this.authService.loginHostName$.next('');

    this.authService.hostName$.next(this.authService.loginHostName$.value)
    localStorage.setItem('loginHostName', this.authService.loginHostName$.value || '');
    this.route.queryParams.subscribe(params => {
      this.firstlogin = params['firstlogin'] ?? false;
    });
  }

  resetPassword() {
    if (this.login.username.trim() == '') {
      alert('Please enter email address');
      return;
    }
    this.authService.UserName$.next(this.login.username || '');
    localStorage.setItem('UserName', this.login.username);
    this.forgotPwd.resetPassword = true;
    this.forgotPwd.forgotPassword = false;
    this.forgotPwd.username = this.login.username;
    this.loginService.resetPassword(this.forgotPwd).subscribe((data) => {
      console.log(data);
      if (data.hasOwnProperty('Message')) {
        if (data.Message == 'NEW_PASSWORD') {
          alert('An email has been sent to your registered emailAddress. Please enter the new password received in that email');
          return;
        }
      }
      alert('An email has been sent to your registered emailAddress. Please enter the confirmation code received in that email');
      this.router.navigate(['/forgotPassword']);
    },
      (error) => {
        console.log(error);
        if (error instanceof HttpErrorResponse) {
          if (error.error.code == 'PasswordResetRequiredException') {
            this.router.navigate(['/resetPassword']);
          }
          else {
            this.errorMessage = `Error: ${error.error.message}`;
          }
        } else {
          this.errorMessage = `Error: ${error.message}`;
        }
      });
  }

  forgotPassword() {
    if (this.login.username.trim() == '') {
      alert('Please enter email address');
      return;
    }
    this.authService.UserName$.next(this.login.username || '');
    localStorage.setItem('UserName', this.login.username);
    this.forgotPwd.resetPassword = false;
    this.forgotPwd.forgotPassword = true;
    this.forgotPwd.username = this.login.username;
    this.loginService.forgotPassword(this.forgotPwd).subscribe((data) => {
      console.log(data);
      if (data.hasOwnProperty('Message')) {
        alert(data.Message);
        return;
      }
      alert('An email has been sent to your registered emailAddress. Please enter the confirmation code received in that email');
      this.router.navigate(['/forgotPassword']);
    },
      (error) => {
        console.log(error);
        if (error instanceof HttpErrorResponse) {
          if (error.error.code == 'PasswordResetRequiredException') {
            this.router.navigate(['/resetPassword']);
          }
          else {
            this.errorMessage = `Error: ${error.error.message}`;
          }
        } else {
          this.errorMessage = `Error: ${error.message}`;
        }
      });
  }

  onSubmit() {
    this.loginService.loginUser(this.login).subscribe((user) => {
      if (user.hasOwnProperty('Message')) {
        alert(user.Message);
        if (user.Message == 'Please reset your password to continue.') {
          this.firstlogin = 'true';
          return;
        }
      }
      this.authService.UserName$.next(this.login.username || '');
      localStorage.setItem('UserName', this.login.username);
      if (user?.User.hasOwnProperty('ChallengeName')) {

        this.authService.Session$.next(user?.User.Session || '');

        localStorage.setItem('Session', user?.User.Session);
        this.router.navigate(['/updatePassword']);
        return;
      }
      this.user = user;
      this.authService.Authorization$.next(this.user?.User.AuthenticationResult.IdToken || '');
      var accessDetails = {
        AccessKey: this.user?.UserDetails.UserAttributes.filter((x) => x.Name == 'custom:accessKey')[0]?.Value,
        AccessToken: this.user?.User.AuthenticationResult.AccessToken,
        AccessAssociation: this.user?.UserDetails.UserAttributes.filter((x) => x.Name == 'custom:accessAssociation')[0]?.Value,
        Type: this.user?.UserDetails.UserAttributes.filter((x) => x.Name == 'custom:type')[0]?.Value,
        UserId: this.user?.UserDetails.UserAttributes.filter((x) => x.Name == 'custom:userId')[0]?.Value
      } as LoggedInUserAccessDetails
      this.authService.AccessDetails$.next(accessDetails);
      localStorage.setItem('accessKey', accessDetails.AccessKey);
      localStorage.setItem('loginType', accessDetails.Type);
      localStorage.setItem('accessDetails', JSON.stringify(accessDetails));
      var stageName = this.parseStage(window.location.hostname) || '';
      if (stageName !== '') {
        this.authService.stage$.next('.' + stageName || '');
        localStorage.setItem('stage', '.' + stageName || '');
      }
      else {
        this.authService.stage$.next('');
        localStorage.setItem('stage', '');
      }

      //localStorage.setItem('tenantId', tenantId || '');
      

      if (accessDetails.Type == 'admin') {
        this.authService.IsAdminUser$.next(true);
        localStorage.setItem('IsAdminUser', 'true');
      }
      else if (accessDetails.Type == 'tenant') {
        this.authService.IsTenantUser$.next(true);
        localStorage.setItem('IsTenantUser', 'true');
      }
      else if (accessDetails.Type == 'merchant') {
        this.authService.IsMerchantUser$.next(true);
        localStorage.setItem('IsMerchantUser', 'true');
      }
      localStorage.setItem('Authorization', this.user?.User.AuthenticationResult.IdToken || '');
      localStorage.setItem('hostName', this.authService.hostName$.value || '');

      this.router.navigate(['/dashboard']);
    },
      (error) => {
        console.log(error);
        if (error instanceof HttpErrorResponse) {
          if (error.error.code == 'PasswordResetRequiredException') {
            this.router.navigate(['/resetPassword']);
          }
          else if (error.error.code == 'NotAuthorizedException') {
            alert(error.error.message);
          }
          else if (error.error.message == 'Please reset your password to continue.') {
            alert(error.error.message);
            this.router.navigate(['/resetPassword']);
          }
          else {
            this.errorMessage = `Error: ${error.error.message}`;
          }
        } else {
          this.errorMessage = `Error: ${error.message}`;
        }
      });
  }

  parseStage(domainName: string) {
    let splits = domainName.split('.');
    console.log(splits);
    if (splits[1] == 'mytrans')
      return '';
    else
      return splits[1];
  };

}
